export default __webpack_public_path__ + "static/media/mountain-bike-v2.2ac03bb7.jpg";